/* src/app/main/ageing/wizard/steps/import-data/ageing-import-data.component.scss */
.chart-container {
  width: 200px;
  height: 200px;
}
canvas {
  width: 100%;
  height: 100%;
}
.progress-section {
  text-align: center;
  margin: 20px 0;
}
.progress-bar {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  height: 20px;
  margin: 10px 0;
}
.progress {
  height: 100%;
  background-color: #4682B4;
  border-radius: 5px;
  transition: width 1s ease;
}
.key {
  font-weight: bold;
}
.data-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 100%;
  overflow-x: auto;
}
.data-preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
  border-radius: 10px;
  overflow: hidden;
}
.data-preview-table th,
.data-preview-table td {
  padding: 8px;
  border: 1px solid #ccc;
  text-align: center;
}
.data-preview-table thead tr {
  background-color: #006f8a;
  color: white;
  font-weight: bold;
}
.data-preview-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}
.data-preview-table tbody tr:nth-child(odd) {
  background-color: #fff;
}
.data-preview-table tr:hover {
  background-color: #e6f7ff;
}
.error-details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 0.95em;
}
.error-details-table th,
.error-details-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: left;
}
.error-details-table th {
  background: #f5f7fa;
  color: #006f8a;
  font-weight: bold;
}
.error-details-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}
.error-details-group h5 {
  margin-top: 16px;
  margin-bottom: 4px;
  color: #4171a8;
}
.summary-preview-container {
  margin-top: 20px;
  margin-bottom: 30px;
  max-width: 30%;
  overflow-x: auto;
}
.summary-details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 0.95em;
}
.summary-details-table th,
.summary-details-table td {
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  text-align: left;
}
.summary-details-table th {
  background: #f5f7fa;
  color: #006f8a;
  font-weight: bold;
}
.summary-details-table tbody tr:nth-child(even) {
  background: #f9f9f9;
}
/*# sourceMappingURL=ageing-import-data.component-3LQTJQ3A.css.map */
